import React from 'react';
import { Texto } from '../Texto';
import { Align, FontSize } from '../../../modules/ReceiptLayouts/Model';
import { isBoolean } from 'util';
export var BlockServicePacket = function (_a) {
    var operationline = _a.operationline, packetName = _a.packetName, fontSize = _a.fontSize, align = _a.align, bold = _a.bold;
    return (React.createElement("div", { style: {
            width: '90%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'flex-start',
        } },
        React.createElement(Texto, { texto: operationline, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold }),
        React.createElement(Texto, { texto: packetName, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold })));
};
var defaultProps = {
    align: Align.Left,
    fontSize: FontSize.normal,
    bold: false
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockServicePacket.tsx
// module id = 1172
// module chunks = 0